import { Component, Input, OnInit } from '@angular/core';

import { IAvatarSettings } from '../../../domains/shared/components/avatar/avatar.component';
import { Usuario } from '../usuario';

@Component({
  selector: 'sgt-usuario-infobar',
  templateUrl: './usuario-infobar.component.html',
  styleUrls: ['./usuario-infobar.component.less'],
})
export class UsuarioInfobarComponent implements OnInit {
  @Input() entity: Usuario;
  /** Se pode realizar o upload da imagem do avatar */
  @Input() canUploadAvatar = false;

  avatarSettings: IAvatarSettings;

  ngOnInit() {
    this.avatarSettings = {
      fullName: this.entity?.nome,
      imageUrl: this.entity?.avatarUrl,
      size: 100,
    };
  }
}
